import script from "./addRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./addRecord.vue?vue&type=script&setup=true&lang=js"

import "./addRecord.vue?vue&type=style&index=0&id=33add393&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33add393"]])

export default __exports__